import Vue from 'vue'
import Router from 'vue-router'

import Index from '../view/index'
import List from '../view/list'
import Article from '../view/article'
import Search from '../view/search'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
    },
    {
      path: '/list/:cid',
      name: 'list',
      component: List,
    },
    {
      path: '/search/:sid',
      name: 'search',
      component: Search,
    },
    {
      path: '/article/:cid/:aid',
      name: 'article',
      component: Article,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js